import React from 'react';
import {useAppraisalsContext} from "../../contexts/AppraisalsContext";
import download from '../../../../common/assets/download-4A4A4A.svg';
import styles from "./styles.module.scss";

const ButtonDownload = ({id}) => {
  const {handleDownload} = useAppraisalsContext();

  return (
    <div className={styles.downloadItemContainer} onClick={() => handleDownload(id)}>
      <img src={download} alt="i"/>
      <span>הורדת</span>
    </div>
  );
};

export default ButtonDownload;